import GoogleRedirectCompo from "@/components/templates/GoogleRedirect/google-redirect-compo";

const GoogleRedirect = ({ resolution }: TemplateProps) => {
  return <GoogleRedirectCompo locale={resolution?.locale} />;
};

export default GoogleRedirect;
